import { render } from "./HomeInicio.vue?vue&type=template&id=fb40208c&scoped=true"
import script from "./HomeInicio.vue?vue&type=script&lang=js"
export * from "./HomeInicio.vue?vue&type=script&lang=js"

import "./HomeInicio.vue?vue&type=style&index=0&id=fb40208c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb40208c"]])

export default __exports__